import { useEffect } from 'react'

/**
 * Toast surfacing the `edges_auto_created` count that the server's
 * Phase 4.3 auto-detection pipeline returns in the /crdt/apply
 * response. Counts > 0 mean Content's edge_detector found new
 * relations (replies_to via @-mention, contradicts via phrase
 * detection, etc) and persisted them automatically.
 *
 * Visibility is derived purely from `count > 0` — no internal state.
 * Parent is responsible for resetting `count` to null/0 to dismiss,
 * either by user action or via the `onDismiss` callback that fires
 * after the 3s auto-dismiss timer.
 */
interface Props {
  count: number | null
  onDismiss?: () => void
}

export function EdgesAutoCreatedToast({ count, onDismiss }: Props) {
  const visible = count != null && count > 0

  useEffect(() => {
    if (!visible) return
    const t = setTimeout(() => {
      onDismiss?.()
    }, 3000)
    return () => clearTimeout(t)
  }, [visible, onDismiss])

  if (!visible) return null

  return (
    <div className="edges-auto-toast" role="status" aria-live="polite">
      <span className="edges-auto-toast__count">{count}</span>
      <span className="edges-auto-toast__label">
        {count === 1 ? 'edge auto-created' : 'edges auto-created'}
      </span>
    </div>
  )
}
